/* =========================================================================
   md-selos.js
   Carrossel mobile da trust bar Matchday (Aura 4.0 / Fury Jersey).
   - Autoplay 4s so no mobile (<1024px)
   - Pause on tap (pointerdown/touchstart no trilho)
   - Sync de dot via scroll manual (swipe)
   - Respeita prefers-reduced-motion e visibilitychange
   ========================================================================= */
(function () {
  'use strict';

  var INTERVAL_MS = 4000;
  var DESKTOP_MIN = 1024;

  function initSelos(root) {
    if (!root || root.dataset.mdSelosInit === '1') return;
    root.dataset.mdSelosInit = '1';

    var trilho = root.querySelector('[data-md-selos-trilho]');
    var items = root.querySelectorAll('[data-md-selos-item]');
    var dots = root.querySelectorAll('[data-md-selos-dot]');

    if (!trilho || items.length === 0) return;

    var currentIndex = 0;
    var timerId = null;
    var paused = false;
    var scrollTimer = null;

    var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isDesktop() {
      return window.innerWidth >= DESKTOP_MIN;
    }

    function normalize(index) {
      var n = items.length;
      return ((index % n) + n) % n;
    }

    function setActive(index) {
      currentIndex = normalize(index);
      for (var i = 0; i < dots.length; i++) {
        if (i === currentIndex) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function goTo(index) {
      if (isDesktop()) return;
      var idx = normalize(index);
      var target = items[idx];
      if (!target) return;
      try {
        trilho.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      } catch (e) {
        trilho.scrollLeft = target.offsetLeft;
      }
      setActive(idx);
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function startAutoplay() {
      if (prefersReduce || isDesktop() || paused) return;
      stopAutoplay();
      timerId = window.setInterval(next, INTERVAL_MS);
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    function pause() {
      if (paused) return;
      paused = true;
      stopAutoplay();
    }

    trilho.addEventListener('scroll', function () {
      if (isDesktop()) return;
      if (scrollTimer !== null) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var trilhoRect = trilho.getBoundingClientRect();
        var centerX = trilhoRect.left + trilhoRect.width / 2;
        var bestIndex = 0;
        var bestDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          var itemCenter = r.left + r.width / 2;
          var dist = Math.abs(itemCenter - centerX);
          if (dist < bestDist) {
            bestDist = dist;
            bestIndex = i;
          }
        }
        if (bestIndex !== currentIndex) {
          setActive(bestIndex);
        }
      }, 150);
    }, { passive: true });

    trilho.addEventListener('pointerdown', pause, { passive: true });
    trilho.addEventListener('touchstart', pause, { passive: true });

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          pause();
          goTo(idx);
        });
      })(d);
    }

    function onVisibility() {
      if (document.hidden) {
        stopAutoplay();
      } else if (!paused) {
        startAutoplay();
      }
    }
    document.addEventListener('visibilitychange', onVisibility);

    var resizeTimer = null;
    function onResize() {
      if (resizeTimer !== null) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (isDesktop()) {
          stopAutoplay();
        } else if (!paused) {
          startAutoplay();
        }
      }, 200);
    }
    window.addEventListener('resize', onResize);

    // Chamado quando o editor tira ou recarrega a seção: sem isso o carrossel
    // antigo seguia rodando escondido a cada ajuste no editor.
    root.__mdSelosDestroy = function () {
      paused = true;
      stopAutoplay();
      if (resizeTimer !== null) window.clearTimeout(resizeTimer);
      if (scrollTimer !== null) window.clearTimeout(scrollTimer);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', onResize);
    };

    setActive(0);
    startAutoplay();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-md-selos]');
    for (var i = 0; i < roots.length; i++) {
      initSelos(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    var root = e.target.querySelector ? e.target.querySelector('[data-md-selos]') : null;
    if (root) initSelos(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e || !e.target || !e.target.querySelectorAll) return;
    var roots = e.target.querySelectorAll('[data-md-selos]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i].__mdSelosDestroy === 'function') roots[i].__mdSelosDestroy();
    }
  });
})();
